<template>
    <div class="box">
        <!-- <div class="history-hot" v-if="isShowHistory">
            <h4>历史记录</h4>
            <van-icon name="delete" class="delete-icon" @click="clearFn" />
            <van-tag
                plain
                type="primary"
                v-for="(item, index) in historyKeywordList"
                :key="index"
                v-if="item"
                @click="goSearch(item)"
                >{{ item }}</van-tag
            >
        </div> -->
        <div class='search-display'>
    <!-- 热门搜索 -->
    <div class='hot-search'>
      <div class='title-text'>
        热门搜索
      </div>
      <div class='hot-search-tags'>
        <span  v-for="(item, index) in hotKeywordList"
                :key="index"
                @click="goSearch(item.title)" class='tags' >{{item.title}}</span>
      </div>
    </div>
</div>
    </div>
</template>

<script>
import { Clearhistory } from '@/https/http'
export default {
    name: "history-hot",
    data() {
        return {
            isShowHistory: 1
        }
    },
    props: ["historyKeywordList", "hotKeywordList"],
    methods: {
        clearFn() {
            Clearhistory().then((res) => {
                console.log(res);
                this.isShowHistory = 0
            })
        },
        goSearch(value) {
            this.$emit('goSearch', value)
        }
    }
};
</script>
<style lang="less" scoped>
.box {
    font-size: 16px;

    span {
        margin-right: 3px;
    }
    .history-hot {
        margin-bottom: 10px;
        position: relative;
        .delete-icon {
            position: absolute;
            top: 10px;
            right: 10px;
        }
    }
}
.search-display {
    background: #fff;
    padding: 10px;
    // margin-top: 50px;
}
.search-display .title-text {
    padding: 15px 0;
    font-size: 15px;
    color: #666;
}
.hot-search .hot-search-tags {
    overflow: hidden;
    font-size: 13px;
    text-align: center;
    padding-bottom: 15px;
}
.hot-search .hot-search-tags .tags {
    display: block;
    max-width: 100%;
    overflow: hidden;
    float: left;
    border-radius: 25px;
    white-space: nowrap;
    text-overflow: ellipsis;
    background-color: #f2f2f2;
    box-sizing: border-box;
    margin-right: 10px;
    margin-bottom: 10px;
    padding: 5px 15px;
}
</style>